import { makeId } from 'utils/selectors';

import { DYNAMIC_VALUES_FULFILLED, IS_FETCHING_COMPONENT } from './const';

/**
 * editor pane reducer
 * @param {object} state - state object for canvas
 * @param {object} action - dispatched action object
 * @returns {object} new state.object after dispatched performing action
 */
const reducer = function editorPaneReducer(state = {}, action = {}) {
  switch (action.type) {
    case DYNAMIC_VALUES_FULFILLED: {
      // save allowed values under a computed key
      const {
        allowedValues: { apiUrl },
        ...rest
      } = action.fieldContract;
      const key = makeId({ ...rest, apiUrl });

      return { ...state, [key]: action.allowedValues };
    }
    case IS_FETCHING_COMPONENT: {
      return { ...state, isFetchingComponent: action.bool };
    }
    default:
      return state;
  }
};

export default reducer;
